import { render } from "./App.vue?vue&type=template&id=56c18116"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=56c18116&lang=css"

import exportComponent from "/Users/rswenson/code/arch/surfacing/src/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__